var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"sd-starpill"},[_c('span',{staticClass:"st"},[_vm._v(_vm._s(_vm.stars))]),_c('span',{staticClass:"num-ltr"},[_vm._v(_vm._s(_vm.score.toFixed(1)))]),_vm._v(" "+_vm._s(_vm.t('of5')))])
}
var staticRenderFns = []

export { render, staticRenderFns }